import React from "react";
import LegalDocPage from "../LegalDoc/LegalDocPage";
import { LegalStructuredBody } from "../LegalDoc/LegalStructuredBody";
import { POLICY_CONTENT } from "./policyContent";

/** Lovable shell + prod Privacy wording in section hierarchy. Route: /policy */
const Policy = () => (
  <LegalDocPage title="Privacy Policy" lastUpdated="May 29th, 2015">
    <LegalStructuredBody
      intro={POLICY_CONTENT.intro}
      sections={POLICY_CONTENT.sections}
    />
  </LegalDocPage>
);

export default Policy;
